<section id="intro-app-development" class="section-bg-dark">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 pl-5">
                <h2 class="text-white">INFRAESTRUCTURA & MICROINFORMÁTICA</h2>
            </div>
        </div>
    </div>
</section>


<section id="mobile">
    <div class="container">

        <div class="row">
            <div class="col-sm-12 col-xs-12">
                <p class="font-medium">
                    Gestionamos infraestructuras cloud y entornos de trabajo digitales para que tu empresa opere
                    con la máxima disponibilidad, seguridad y rendimiento. Desde la migración a la nube hasta el
                    soporte técnico del día a día, nos ocupamos de que la tecnología nunca sea un obstáculo.
                </p>
            </div>
        </div>

        <div class="row justify-mobile">
            <div class="col-sm-4 col-xs-12 text-right">
                <div class="row">
                    <div class="col-12 orden3 mt-20">
                        @for (section of firstTwoSections; track section) {
                        <div class="row apps3">
                            <div class="col-9 col-xs-12">
                                <h3 class="icon-title">{{ section.title }}</h3>
                            </div>

                            <div class="first-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>

                            <div class="col-12">
                                <p>{{ section.description }}</p>
                            </div>
                            <div class="second-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-xs-12 img-completa">
                <img src="assets/img/tablet_services.webp" alt="Soluciones Tecnológicas">
            </div>
            <div class="col-sm-4 col-xs-12 text-left">
                <div class="row">
                    <div class="col-12 orden3 mt-20">
                        @for (section of lastTwoSections; track section) {
                        <div class="row apps3">
                            <div class="first-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>

                            <div class="col-9 col-xs-12">
                                <h3 class="icon-title">{{ section.title }}</h3>
                            </div>

                            <div class="col-12">
                                <p>{{ section.description }}</p>
                            </div>
                            <div class="second-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section id="cloud-platforms" style="padding: 40px 0;">
    <div class="container">
        <div class="row p-2">
            <div class="col-xs-12 w-100 text-center p-4">
                <h2>PLATAFORMAS CLOUD</h2>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            @for (logo of logos; track logo) {
            <div class="col-6 col-md-3 text-center p-3">
                <img [src]="logo.src" [alt]="logo.alt" style="max-height: 60px; max-width: 160px; object-fit: contain;">
            </div>
            }
        </div>
    </div>
</section>